<template>
  <div>
    <div class="card">
      <div class="card-body">
        <h5 class="mb-4">
          <strong>Tambah Obat Baru</strong>
        </h5>
        <a-form :form="form"  @submit="handleSubmit">
          <a-form-item :label-col="labelCol" :wrapper-col="wrapperCol" label="Nama Obat">
            <a-input
              :disabled="submitting"
              placeholder="Masukkan Nama Obat"
              v-decorator="['name', {rules: [{ required: true, message: 'Nama obat harus diisi!' }]}]"
            />
          </a-form-item>
          <a-form-item :label-col="labelCol" :wrapper-col="wrapperCol" label="Deskripsi">
            <a-input
              :disabled="submitting"
              placeholder="Masukkan deskripsi obat"
              v-decorator="['description', {rules: [{ required: true, message: 'Deskripsi obat harus diisi!' }]}]"
            />
          </a-form-item>
          <a-form-item :label-col="labelCol" :wrapper-col="wrapperCol" label="Status">
            <a-select
              :disabled="submitting"
              v-decorator="[
                'status',
                { rules: [{ required: true, message: 'Status harus diisi!' }] },
              ]"
              placeholder="Status"
            >
              <a-select-option v-for="status in statusList" :key="status.id" :value="status.id">
                  {{status.name}}
               </a-select-option>
            </a-select>
          </a-form-item>
          <button type="submit" class="btn btn-success px-5" :disabled="submitting">Simpan Data</button>
        </a-form>
      </div>
    </div>
  </div>
</template>
<script>

import router from '@/router'
import { create } from '@/services/axios/api/obat'
import { getAll } from '@/services/axios/api/city'
import { notification } from 'ant-design-vue'

const labelCol = {
  xs: { span: 24 },
  sm: { span: 4 },
}
const wrapperCol = {
  xs: { span: 24 },
  sm: { span: 12 },
}
export default {
  data: function () {
    return {
      form: this.$form.createForm(this),
      labelCol,
      wrapperCol,
      cityList: [],
      submitting: false,
      statusList: [{ id: 1, name: 'Aktif' }, { id: 0, name: 'Tidak Aktif' }],
    }
  },
  created() {
    this.getCityList()
  },
  methods: {
    async getCityList() {
      const res = await getAll()
      this.cityList = res
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields(async (err, values) => {
        if (!err) {
          this.submitting = true
          console.log('Received values of form: ', values)
          try {
            const res = await create(values)
            if (res && res.data) {
              notification.success({
                message: 'Sukses',
                description: 'Data berhasil ditambahkan',
                duration: 5,
              })
              router.push('/obat')
            }
            this.submitting = false
          } catch (e) {
            this.submitting = false
          }
        }
      })
    },
  },
}
</script>
